import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=10bd551c&scoped=true"
import script from "./tenant.vue?vue&type=script&lang=js"
export * from "./tenant.vue?vue&type=script&lang=js"
import style0 from "./tenant.vue?vue&type=style&index=0&id=10bd551c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd551c",
  null
  
)

export default component.exports